import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { fetchUserProductLicence } from "../actions/licences";
import ExistingLicenceBanner from '../components/products/ExistingLicenceBanner';
import { doRemoveUser } from '../actions/subscriptions';

const mapStateToProps = ({licencesByUserId}, {userId, productId}) => {
  const userLicences = licencesByUserId[userId];
  const licence = (userLicences && userLicences[productId]) || null;

  // don't display the licence if it's from the user's subscription
  if( licence 
    && licence.owner 
    && licence.owner.id !== userId 
  ) {
    return {licence};
  }

  return {};
}

const mapDispatchToProps = (dispatch, {userId, productId}) => {
  return {
    fetchLicence: () => 
      dispatch(fetchUserProductLicence(userId, productId)),
    revokeLicence: subscriptionId =>
      dispatch(doRemoveUser(subscriptionId, userId)),
  }
}

const container = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ExistingLicenceBanner
);

container.propTypes = {
  userId: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
}

export default container;



// WEBPACK FOOTER //
// ./src/containers/ExistingLicenceBanner.js